// Polyfill HTMLDialogElement and BigInt for older OS/browsers
if (typeof window !== 'undefined') {
  // Fix missing HTMLDialogElement
  if (typeof window.HTMLDialogElement === 'undefined') {
    class FakeDialog extends HTMLElement {
      show() {}
      showModal() {}
      close() {}
    }
    window.HTMLDialogElement = FakeDialog;
    localStorage.setItem("updateRequired","true");
  }

  // Fix missing BigInt
  if (typeof BigInt === 'undefined') {
    window.BigInt = function (n) {
      // Fallback: convert to Number
      return Number(n);
    };
    localStorage.setItem("updateRequired","true");
  }
}
